import React, { useEffect, useState } from 'react';
import { GlobeIcon } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
interface Language {
  code: string;
  name: string;
  flag: string;
  url: string;
}
interface LanguageSwitcherProps {
  currentLanguage?: string;
  languages?: Language[];
}
const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  currentLanguage = 'en',
  languages = [{
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
    url: '/'
  }, {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸',
    url: '/es'
  }, {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
    url: '/fr'
  }, {
    code: 'pt',
    name: 'Português',
    flag: '🇧🇷',
    url: '/pt'
  }]
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // Determine current language based on URL path
  const [currentLang, setCurrentLang] = useState(languages.find(lang => lang.code === currentLanguage) || languages[0]);
  useEffect(() => {
    // Update current language based on URL
    const path = location.pathname;
    const langPrefix = path.split('/')[1];
    // Find language by prefix
    const matchedLang = languages.find(lang => lang.url === `/${langPrefix}` && lang.code !== 'en');
    if (matchedLang) {
      setCurrentLang(matchedLang);
    } else {
      // Default to English if no match
      setCurrentLang(languages[0]);
    }
  }, [location.pathname, languages]);
  const handleLanguageChange = (language: Language) => {
    setIsOpen(false);
    // Get current path without language prefix
    const currentPath = location.pathname;
    let newPath = language.url;
    // If we're on a subpage like "telecoms", maintain that in the URL
    if (currentPath.includes('telecoms')) {
      newPath = language.code === 'en' ? '/telecoms' : `${language.url}/telecoms`;
    }
    navigate(newPath);
  };
  return <div className="relative" data-id="element-140">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center text-gray-600 hover:text-[#54d4cb] font-medium" aria-expanded={isOpen} aria-haspopup="true" data-id="element-141">
        <span className="mr-1" aria-hidden="true" data-id="element-142">
          {currentLang.flag}
        </span>
        <span className="sr-only md:not-sr-only md:inline-block" data-id="element-143">
          {currentLang.name}
        </span>
        <GlobeIcon className="h-4 w-4 ml-1" data-id="element-144" />
      </button>
      {isOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50" role="menu" aria-orientation="vertical" aria-labelledby="language-menu" data-id="element-145">
          <div className="py-1" data-id="element-146">
            {languages.map(language => <button key={language.code} onClick={() => handleLanguageChange(language)} className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-[#54d4cb] w-full text-left" role="menuitem" lang={language.code} data-id="element-147">
                <span className="mr-2" aria-hidden="true" data-id="element-148">
                  {language.flag}
                </span>
                {language.name}
              </button>)}
          </div>
        </div>}
    </div>;
};
export default LanguageSwitcher;